import Grid from "@mui/material/Grid";
import React from "react";
import CharErholungsproben from "./Schaden/CharErholungsproben";
import CharPDmg from "./Schaden/CharPDmg";
import {CharWUND} from "./Schwellen/CharWUND";
import CharKV from "./Verteidigung/CharKV";
import CharMV from "./Verteidigung/CharMV";
import CharSV from "./Verteidigung/CharSV";
import CharBEW from "./Schwellen/CharBEW";
import CharTOT from "./Schwellen/CharTOT";
import {s_char} from "../_signals/s_char";
import {useSignals} from "@preact/signals-react/runtime";
import CharPR from "./Armor/CharPR";
import CharMR from "./Armor/CharMR";
import CharMDmg from "./Schaden/CharMDmg";
import AttributesDisplay from "./Attributes/AttributesDisplay";
import AttributesCreation from "./Attributes/AttributesCreation";
import CharBlutschaden from "./Schaden/CharBlutschaden";
import CharSchaden from "./Schaden/CharSchaden";
import CharWunden from "./Schaden/CharWunden";
import CharBlutwunden from "./Schaden/CharBlutwunden";
import Karma from "./Karma/Karma";
import Mods from "./Mods/Mods";


export default function Char() {
    useSignals()


    return <Grid className={'player'}>
        {s_char.value.cc_attr ? <AttributesDisplay></AttributesDisplay>:<AttributesCreation></AttributesCreation>}
        <Grid container style={{paddingTop: 4, paddingBottom: 4, alignItems: "stretch"}}
              spacing={1}
              alignItems="stretch">
            <CharKV></CharKV>
            <CharMV></CharMV>
            <CharSV></CharSV>
            <CharWUND></CharWUND>
            <CharBEW></CharBEW>
            <CharTOT></CharTOT>
        </Grid>
        <Grid container style={{paddingTop: 4, paddingBottom: 4, alignItems: "stretch"}}
              spacing={1}
              alignItems="stretch">
            <Grid item xs={6} sm={3}>
                <CharPR></CharPR>
            </Grid>
            <Grid item xs={6} sm={3}>
                <CharMR></CharMR>
            </Grid>
            <Grid item xs={6} sm={3}>
                <CharSchaden></CharSchaden>
            </Grid>
            <Grid item xs={6} sm={3}>
                <CharBlutschaden></CharBlutschaden>
            </Grid>
        </Grid>
        <Grid container style={{paddingTop: 4, paddingBottom: 4, alignItems: "stretch"}}
              spacing={1}
              alignItems="stretch">
            <Grid item xs={6} sm={3}>
                <CharWunden></CharWunden>
            </Grid>
            <Grid item xs={6} sm={3}>
                <CharBlutwunden></CharBlutwunden>
            </Grid>
            <Grid item xs={6} sm={3}>
                <CharPDmg/>
            </Grid>
            <Grid item xs={6} sm={3}>
                <CharMDmg></CharMDmg>
            </Grid>
        </Grid>
        <Grid container style={{paddingTop: 4, paddingBottom: 4, alignItems: "stretch"}}
              spacing={1}
              alignItems="stretch">
            <Grid item xs={12} sm={4}>
                <CharErholungsproben/>
            </Grid>
            <Grid item xs={12} sm={4}>
                <Karma></Karma>
            </Grid>
            <Grid item xs={12} sm={4}>
                    <Mods/>
            </Grid>
        </Grid>
    </Grid>

}
